import { useState } from "react";
import { useGetOne, useTranslate } from "ra-core";
import { BookOpen } from "lucide-react";

import { Button } from "@/components/ui/button";
import {
  Sheet,
  SheetContent,
  SheetHeader,
  SheetTitle,
} from "@/components/ui/sheet";
import { useIsMobile } from "@/hooks/use-mobile";
import { ProcedureBody } from "@/tenax/procedures/ProcedurePages";
import type { ChecklistTemplate, Procedure } from "./taskData";

// The procedure of the task's template, one tap away (task 1.3, D-030).
// Nothing shows when the template has no procedure.
export const TaskProcedureButton = ({ templateId }: { templateId: number }) => {
  const translate = useTranslate();
  const isMobile = useIsMobile();
  const [isOpen, setOpen] = useState(false);
  const { data: template } = useGetOne<ChecklistTemplate>(
    "checklist_templates",
    { id: templateId },
  );
  const { data: procedure } = useGetOne<Procedure>(
    "procedures",
    { id: template?.procedure_id ?? 0 },
    { enabled: !!template?.procedure_id },
  );

  if (!procedure) return null;

  return (
    <>
      <Button
        variant="outline"
        className="self-start"
        onClick={() => setOpen(true)}
      >
        <BookOpen />
        {translate("tenax.tasks.procedures.open")}
      </Button>
      <Sheet open={isOpen} onOpenChange={setOpen}>
        <SheetContent
          side={isMobile ? "bottom" : "right"}
          className="max-h-[90dvh] overflow-y-auto"
        >
          <SheetHeader className="p-4 pb-0">
            <SheetTitle>{procedure.title}</SheetTitle>
          </SheetHeader>
          <div className="p-4">
            <ProcedureBody procedure={procedure} />
          </div>
        </SheetContent>
      </Sheet>
    </>
  );
};
